export const provincesList = [
  { id: 1, label: 'provinces.select', value: '' },
  { id: 2, label: 'provinces.AB', value: 'Alberta' },
  { id: 3, label: 'provinces.BC', value: 'British Columbia' },
  { id: 4, label: 'provinces.MB', value: 'Manitoba' },
  { id: 5, label: 'provinces.NB', value: 'New Brunswick' },
  {
    id: 6,
    label: 'provinces.NL',
    value: 'Newfoundland and Labrador',
  },
  { id: 7, label: 'provinces.NT', value: 'Northwest Territories' },
  { id: 8, label: 'provinces.NS', value: 'Nova Scotia' },
  { id: 9, label: 'provinces.NU', value: 'Nunavut' },
  { id: 10, label: 'provinces.ON', value: 'Ontario' },
  { id: 11, label: 'provinces.PE', value: 'Prince Edward Island' },
  { id: 12, label: 'provinces.QC', value: 'Quebec' },
  { id: 13, label: 'provinces.SK', value: 'Saskatchewan' },
  { id: 14, label: 'provinces.YT', value: 'Yukon' },
];

export const maritalStatusList = [
  { id: 1, label: 'maritalStatus.select', value: 'Select' },
  { id: 2, label: 'maritalStatus.single', value: 'Single' },
  { id: 3, label: 'maritalStatus.married', value: 'Married' },
  { id: 4, label: 'maritalStatus.commonLaw', value: 'Common-Law' },
  { id: 5, label: 'maritalStatus.separated', value: 'Separated' },
  { id: 6, label: 'maritalStatus.divorced', value: 'Divorced' },
  { id: 7, label: 'maritalStatus.widowed', value: 'Widowed' },
];
